module.exports = __webpack_public_path__ + "static/portfolio-9-48b8d8ce3f8d2df1eb742f10eaeef26f.jpg";